export default {
  confetti: () => import('./confetti.json'),
  goldenShower: {
    mobile: () => import('./goldenShower.json'),
    tablet: () => import('./goldenShower.json'),
    desktop: () => import('./goldenShower.desktop.json'),
  },
};
